__turbopack_context__.v({
  "button": "winnersHistoryCarousel-module__Pd_cdq__button",
  "carousel": "winnersHistoryCarousel-module__Pd_cdq__carousel",
  "imageFrame": "winnersHistoryCarousel-module__Pd_cdq__imageFrame",
  "item": "winnersHistoryCarousel-module__Pd_cdq__item",
  "mobileStack": "winnersHistoryCarousel-module__Pd_cdq__mobileStack",
  "track": "winnersHistoryCarousel-module__Pd_cdq__track",
});
